import { BackgroundSelection } from "./Background/BackgroundSelection";
import { LogoUpload } from "./LogoUpload/LogoUpload";
import styles from "./NewScene.module.scss";

interface Props {
	handleSaveForm: () => void;
};

const NewScene: React.FC<Props> = ({handleSaveForm}) => {
	return (
		<div className={styles.sceneContainer}>
			{/* <CameraSelection /> */}
			<BackgroundSelection />
			{/* <LogoUpload /> */}
			<button className={`${styles.saveButton}`} onClick={handleSaveForm}>
				Сохранить
			</button>
		</div>
	);
};

export default NewScene;
